/**********************************************************************
 *
 * Copyright (C) 2022 Almendo Technologies GmbH
 * Copyright (C) 2022 Marcus Harringer
 *
 * All Rights Reserved.
 *
 * All information contained herein is, and remains the property of
 * Marcus Harringer. The intellectual and technical concepts contained
 * herein are proprietary to Marcus Harringer and may be covered
 * copyright law. Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written permission
 * is obtained from Marcus Harringer.
 *
 ***********************************************************************/
import { Link as RouterLink } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { Box, Card, CardContent, Container, Divider, Link, Typography } from '@mui/material';

//COMPONENTS
import AuthBanner from '../../components/authentication/AuthBanner';
import { LoginAmplify } from '../../components/authentication/login';
import LogoColored from '../../components/LogoColored';

//HOOKS
import { useTranslation } from 'react-i18next';
import useAuth from '../../hooks/useAuth';

//ICONS
import IconSecurity from '@mui/icons-material/Security';

/**********************************************************************
 * PAGE 
***********************************************************************/
const Login = () => {
  const { platform } = useAuth();
  const { t } = useTranslation('nls');

  return <>
    <Helmet>
      <title>Login | bluSensor&reg;</title>
    </Helmet>
    <Box
      sx={{
        backgroundColor: 'background.default',
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh'
      }}
    >
      <AuthBanner />
      <Container
        maxWidth="sm"
        sx={{ py: 5 }}
      >
        {/*
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            mb: 8
          }}
        >
          <RouterLink to="/">
            <LogoColored
              sx={{
                height: 192,
                width: 64
              }}
            />
          </RouterLink>
        </Box>
            */}
        <Card>
          <CardContent
            sx={{
              display: 'flex',
              flexDirection: 'column',
              p: 4
            }}
          >
            <Box
              sx={{
                alignItems: 'center',
                display: 'flex',
                justifyContent: 'space-between',
                mb: 3
              }}
            >
              <div>
                <Typography
                  color="textPrimary"
                  gutterBottom
                  variant="h4"
                >
                  {t('auth.NLS_LOGIN')}
                </Typography>
                <Typography
                  color="textSecondary"
                  variant="body2"
                >
                  {t('auth.NLS_LOGIN_SUBTITLE')}
                </Typography>
              </div>
              <Box
                sx={{
                  height: 64,
                  '& > img': {
                    maxHeight: '100%',
                    width: 'auto'
                  }
                }}
              >

                <IconSecurity />

              </Box>
            </Box>
            <Box
              sx={{
                flexGrow: 1,
                mt: 3
              }}
            >
              {platform === 'Amplify' && <LoginAmplify />}
            </Box>
            <Divider sx={{ my: 3 }} />
            <Link
              color="textSecondary"
              component={RouterLink}
              to="/authentication/register"
              variant="body2"
              underline="hover">
              {t('auth.NLS_CREATE_ACCOUNT')}
            </Link>
            {platform === 'Amplify' && (
              <Link
                color="textSecondary"
                component={RouterLink}
                sx={{ mt: 1 }}
                to="/authentication/password-recovery"
                variant="body2"
                underline="hover">
                {t('auth.NLS_FORGOT_PASSWORD')}
              </Link>
            )}
          </CardContent>
        </Card>
      </Container>
    </Box>
  </>;
};

export default Login;
